export interface CoreLibConfig {
  platform: 'web' | 'ios' | 'android';
  hostname: string;
  isNative: boolean;
  isIOS: boolean;
  isAndroid: boolean;
  isProductionBuild: boolean;
  isTestRun: boolean;
  isStorybook: boolean;
  isChromatic: boolean;
  appId?: string;
  segmentApiKey: string;
  customerIoApiKey: string;
  googleAnalyticsMeasurementId: string;
  googleAnalyticsApiKey: string;
  appVersion: string;
  mainLayoutSelector?: string;
}

let _config: CoreLibConfig | null = null;

export function setCoreConfig(config: CoreLibConfig): void {
  _config = config;
}

export function getCoreConfig(): CoreLibConfig {
  if (!_config) throw new Error('CoreLibConfig not initialized — wrap your app with <ConfigProvider>');
  return _config;
}
